import axios from "axios";

const ATOMIC_API_ENDPOINTS = process.env.WAX_CHAIN === 'mainnet'
  ? [
    'https://wax-atomic-api.eosphere.io/atomicassets/v1',
    'https://wax-atomic.alcor.exchange/atomicassets/v1',
    'https://wax-aa.eosdac.io/atomicassets/v1',
    'https://wax.eosusa.io/atomicassets/v1',
    'https://atomic.wax.detroitledger.tech/atomicassets/v1',
    'https://wax-aa.eu.eosamsterdam.net/atomicassets/v1',
    'https://atomic.wax.eosrio.io/atomicassets/v1',
  ]
  : ['https://test.wax.api.atomicassets.io/atomicassets/v1'];

let currentEndpointIndex = 0;

export const getDataFromAtomicApi = async (path) => {
  const startIndex = currentEndpointIndex;

  for (let attempt = 0; attempt < ATOMIC_API_ENDPOINTS.length; attempt += 1) {
    const endpointIndex = (startIndex + attempt) % ATOMIC_API_ENDPOINTS.length;

    try {
      // Try providers sequentially to avoid duplicating every successful request.
      // eslint-disable-next-line no-await-in-loop
      const { data: { data } } = await axios.get(
        `${ATOMIC_API_ENDPOINTS[endpointIndex]}/${path}`,
        { timeout: 10000 }
      );

      currentEndpointIndex = endpointIndex;
      return data;
    } catch (e) {
      const status = e.response && Number(e.response.status);
      const retryable = !e.response || status === 429 || status >= 500;

      if (!retryable)
        throw e;

      if (attempt === ATOMIC_API_ENDPOINTS.length - 1)
        throw new Error('NetworkError! All AtomicAssets endpoints are unavailable.');
    }
  }
};
